<ng-container>
  <div class="top-nav" #topNav>
    <div class="top-nav__row">
      <div class="top-nav__left top-nav__col">
        <div class="top-nav__lang">
          <div *ngFor="let lang of inactiveLangs"  (click)="toggleLang()">
            <div *ngIf="lang.isActive" class="top-nav__lang--picker">
              <img class="top-nav__lang--flag" src="{{ lang.image }}" loading="lazy" />
              <p class="top-nav__lang--text">{{ header.languageName }}</p>
              <svg [@arrow]="langState" xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8">
                <path id="Polygon_1" data-name="Polygon 1" d="M5,0l5,8H0Z" transform="translate(10 8) rotate(180)" />
              </svg>
            </div>
          </div>
          <div class="top-nav__lang--dropdown" [@items]="langState">
            <div *ngFor="let lang of inactiveLangs">
              <div class="top-nav__lang--dropdown--items" *ngIf="lang.isActive === false" (click)="langPicker(lang.url)">
                <img class="top-nav__lang--flag" src="{{ lang.image }}" loading="lazy" />
                <p *ngIf="lang?.url" class="top-nav__lang--text">{{ lang.isoCode }}</p>
              </div>
            </div>
          </div>
        </div>
        <a *ngIf="header && header.phone" href="tel:{{ header.phone }}"><p class="top-nav__phone">{{ header.phone }}</p></a>
        <a *ngIf="header?.contactPage?.url" href="{{ header.contactPage.url }}">{{ header.contactPage.name }}</a>
      </div>
      <div class="top-nav__right top-nav__col" #topNavLinksEl>
        <a *ngIf="header?.demoPage"
           href="{{ header.demoPage.url }}"
           ubl-link="{{header.demoPage.type}}"
           ubl-link-target="{{header.demoPage.target}}">
          <button type="button" class="bg-demo-button">{{ header.demoPage.name }}</button>
        </a>
        <a *ngIf="header?.buyPage"
           href="{{ header.buyPage.url }}"
           ubl-link="{{header.buyPage.type}}"
           ubl-link-target="{{header.buyPage.target}}">
          <button type="button" class="bg-buy-button">{{ header.buyPage.name }}</button>
        </a>
        <a *ngIf="header?.loginPage"
           href="{{ header.loginPage.url }}"
           ubl-link="{{header.loginPage.type}}"
           ubl-link-target="{{header.loginPage.target}}">
          <button type="button" class="bg-login-button">{{ header.loginPage.name }}</button>
        </a>
      </div>
    </div>
  </div>

  <header class="header" #headerEl>
    <div class="header__container">
      <a [routerLink]="'/'" class="header__logo">
        <app-picture *ngIf="header?.logo" [data]="header.logo"></app-picture>
      </a>

      <div class="top-nav__lang">
        <div *ngFor="let lang of inactiveLangs"  (click)="toggleLang()">
          <div *ngIf="lang.isActive" class="top-nav__lang--picker">
            <img class="top-nav__lang--flag" src="{{ lang.image }}" loading="lazy" />
            <p class="top-nav__lang--text">{{ header.languageName }}</p>
            <svg [@arrow]="langState" xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8">
              <path id="Polygon_1" data-name="Polygon 1" d="M5,0l5,8H0Z" transform="translate(10 8) rotate(180)" />
            </svg>
          </div>
        </div>
        <div class="top-nav__lang--dropdown" [@items]="langState">
          <div *ngFor="let lang of inactiveLangs">
            <div class="top-nav__lang--dropdown--items" *ngIf="lang.isActive === false" (click)="langPicker(lang.url)">
              <img class="top-nav__lang--flag" src="{{ lang.image }}" loading="lazy" />
              <p *ngIf="lang?.url" class="top-nav__lang--text">{{ lang.isoCode }}</p>
            </div>
          </div>
        </div>
      </div>

      <nav class="header__navigation" #navigationEl>
        <app-top-level-navigation [items]="navigation"
                                  [navLength]="120">
        </app-top-level-navigation>
      </nav>
      <button class="mobile-menu-btn" (click)="toggleMobileMenu()">
        <img src="{{burger}}" alt="{{'header.MobileMenu.alt' | translate}}" width="45" height="27" loading="lazy" />
      </button>
    </div>

    <ng-content></ng-content>
  </header>

  <div #mobileNavEl class="mobile-nav" [@items]="navState">
      <div class="mobile-nav__buttons">
        <a *ngIf="header?.demoPage?.url" class="mobile-nav__buttons--item" href="{{ header.demoPage.url }}"><button type="button" class="bg-demo-button">{{ header.demoPage.name }}</button></a>
        <a *ngIf="header?.buyPage?.url" class="mobile-nav__buttons--item" href="{{ header.buyPage.url }}"><button type="button" class="bg-demo-button">{{ header.buyPage.name }}</button></a>
        <a *ngIf="header?.loginPage?.url" class="mobile-nav__buttons--item" href="{{ header.loginPage.url }}"><button type="button" class="bg-login-button">{{ header.loginPage.name }}</button></a>
      </div>

      <div class="mobile-nav__line"></div>

      <nav class="mobile-nav-items">
        <app-top-level-navigation [items]="navigation"></app-top-level-navigation>
      </nav>

      <div class="mobile-nav__line"></div>

      <a *ngIf="header?.contactPage?.url" class="mobile-nav__last" href="{{ header.contactPage.url }}">{{ header.contactPage.name }}</a>

  </div>
</ng-container>
